import { Stack } from "@mui/material";
import { ReuseEllipsisTooltip } from "../ReuseEllipsisTooltip";
import { TableColumnType } from "../../../types/genereal";

type Props = {
  columns: TableColumnType[];
};

export const ClientListHeader = ({ columns }: Props) => {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        width: "100%",
      }}
    >
      {columns.map(({ key, label, minWidth, maxWidth, bgColor, textAlign }) => (
        <Stack
          key={key}
          sx={{
            minWidth,
            maxWidth,
            borderBottom: bgColor ? "none" : "1px solid #DEDEDE",
            backgroundColor: bgColor,
            p: "16px 0 16px 16px",
            borderTopLeftRadius: key === "index" ? "8px" : undefined,
            width: "100%",
          }}
        >
          <ReuseEllipsisTooltip
            tooltip={label}
            children={label}
            style={{
              fontSize: "14px",
              lineHeight: "26px",
              fontWeight: 500,
              color: "#232323",
              textAlign: textAlign,
            }}
          />
        </Stack>
      ))}
    </Stack>
  );
};
